import type { ErrorInfo } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

export interface ErrorBoundaryProps {
    FallbackComponent?: React.ComponentType<FallbackProps>;
    children: React.ReactNode;
    onFatalError?: () => void;
}

const ErrorFallback: React.FC = () => null;

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children, onFatalError, FallbackComponent }) => {
    const onError = (error: Error, info: ErrorInfo) => {
        onFatalError?.();
        console.error(error, info);
    };

    return (
        <ReactErrorBoundary FallbackComponent={FallbackComponent ?? ErrorFallback} onError={onError}>
            {children}
        </ReactErrorBoundary>
    );
};
